import { Outlet } from 'react-router-dom';

export const RootLayout = () => <Outlet />;
